import {JsToClientCommand} from '../jsToClientCommand';
import {ClientCommands} from '../clientCommands';

export class EnableSoundCommand extends JsToClientCommand<null> {
    constructor() {
        super(ClientCommands.ENABLE_SOUND);
    }
}
